/* ==================================================
 *  Carousel
 *  https://getbootstrap.com/examples/carousel/
 *  ==================================================*/

(function () {

  'use strict';

  var $target = $('[data-ride="carousel"]');
  var $item = $('.carousel-inner .item');
  var $nav = $('.carousel-indicators li');

  $nav.on('click', function () {
    var $this = $(this);

    $this.parent().find('li').removeClass('active');
    $this.addClass('active');
  });

  $target.hammer().on('swiperight', function () {
    $(this).find('[data-slide="prev"]').trigger('click');
  });

  $target.hammer().on('swipeleft', function () {
    $(this).find('[data-slide="next"]').trigger('click');
  });

})();
